import { render, staticRenderFns } from "./createCurrencyQuotes.vue?vue&type=template&id=3fcbe4e0&"
import script from "./createCurrencyQuotes.vue?vue&type=script&lang=js&"
export * from "./createCurrencyQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports